import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { threadList, signUp } from '@/api/mg';
import { formatDateTime } from '@/utils/util';
import $ from 'jquery';

// const threadListParams = { page: 1, perPage: 20 }
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 1,
  sequence: 0,
  'filter[categoryids][0]': 2
};
export default {
  data: function data() {
    return {
      totalPage: 0,
      loading: false,
      finished: false,
      isLoading: false,
      activityData: [],
      itemArr: [{
        isJoin: true
      }, {
        isJoin: false
      }, {
        isJoin: true
      }, {
        isJoin: true
      }, {
        isJoin: false
      }, {
        isJoin: true
      }, {
        isJoin: true
      }],
      showNoData: false
    };
  },
  created: function created() {
    threadListParams.page = 1;
    this.getThreadList(threadListParams);
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('12345');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $('.container').css('padding-top', pxSize);
        }
      }
    });
  },
  methods: {
    toJoin: function toJoin(type, threadId, item) {
      var _this = this;
      if (new Date() < Date.parse(item.disTime)) {
        return;
      }
      signUp({
        threadId: threadId,
        type: type,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function (res) {
        if (res.Code === 0) {
          if (item.activity_registration) {
            // 取消加入
            item.activity_registration = 0;
            _this.$toast(_this.$t('cancelJoin'));
          } else {
            // 加入
            item.activity_registration = 1;
            _this.$toast(_this.$t('signJoin'));
          }
        } else {
          // this.$toast(res.Message)
          // this.$toast(this.$t('NoData'))
          var timer = setTimeout(function () {
            _this.$router.back();
            clearTimeout(timer);
          }, 1000);
        }
      });
    },
    toSign: function toSign(type, threadId, item) {
      var _this2 = this;
      signUp({
        threadId: threadId,
        type: type,
        token: JSON.parse(localStorage.getItem('appParams')).token
      }).then(function (res) {
        if (res.Code === 0) {
          _this2.$toast(res.Message);
          if (item.activity_registration) {
            item.activity_registration = 0;
          } else {
            item.activity_registration = 1;
          }
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    onLoad: function onLoad() {
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
    },
    getThreadList: function getThreadList(params) {
      var _this3 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (res.Data.pageData.length === 0) {
            _this3.showNoData = true;
            // this.$toast('No Data')
          }

          _this3.activityData = [];
          res.Data.pageData.forEach(function (item) {
            // if (new Date() < Date.parse(item.start_at)) {
            //   console.log(new Date() < Date.parse(item.start_at), item)

            //   item.isDisabled = true
            // }
            item.disTime = item.start_at.replace(/-/g, '/');
            item.end_time2 = item.end_at.replace(/-/g, '/');
          });
          _this3.totalPage = res.Data.totalPage;
          _this3.activityData = [].concat(_toConsumableArray(_this3.activityData), _toConsumableArray(res.Data.pageData));
          console.log(_this3.activityData, res.Data.pageData);
          _this3.activityData.forEach(function (itm) {
            itm.isDisabled = false;
            itm.start_at1 = formatDateTime(itm.start_at, 1);
            itm.end_time = itm.end_at;
            itm.end_at1 = formatDateTime(itm.end_at, 1);
          });
          _this3.loading = false;
          _this3.isLoading = false;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    onRefresh: function onRefresh() {
      this.finished = false;
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
    },
    toDetail: function toDetail(val, threadId, postCount) {
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
      } else {
        this.$router.push({
          path: '/social/detail',
          query: {
            from: val,
            threadId: threadId,
            postCount: postCount
          }
        });
      }
    }
  }
};